import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { XLarge } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import ShopBlocks from '@outdoor-voices/ui/dist/components/ShopBlocks';
import { DOB_LABEL, FAV_COPY, FORM_SUBTITLE, FORM_TITLE, INFLUENCER_PLATFORMS_LABEL, INFLUENCER_PLATFORMS, OF_AGE_LABEL, OPT_IN_LABEL, referrerOptions, states, SUBMIT_URL, SUCCESS_TITLE, SUCESS_SUBTITLE, UNDERGRAD_LABEL, WHY_COPY } from './constants';
import { DT } from '../../config/constants';
import { OV_SUBSCRIBE_URL } from '../../config/theme';
import addClass from '../../utils/dom/addClass';
import Button from '../Button';
import CheckBox from '../CheckBox';
import css from './FormManager.module.scss';
import Overlay from '../Overlay';
import removeClass from '../../utils/dom/removeClass';
import Select from '../Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var noScroll = 'no-scroll';

var fixScroll = function fixScroll(shouldAdd) {
  var html = document.documentElement;

  if (html) {
    var func = shouldAdd ? addClass : removeClass;
    func(html, noScroll);
  }
};

var getDaysInMonth = function getDaysInMonth(monthNum) {
  if (monthNum === 1) {
    return 29;
  }

  if (monthNum === '' || [0, 2, 4, 6, 7, 9, 11].indexOf(monthNum) > -1) {
    return 31;
  }

  return 30;
};

var getPaddedNumString = function getPaddedNumString(num) {
  return "".concat(num + 1).padStart(2, '0');
};

var RadioGroup = function RadioGroup(_ref) {
  var groupName = _ref.groupName,
      groupLabel = _ref.groupLabel,
      long = _ref.long,
      onChange = _ref.onChange,
      radios = _ref.radios,
      required = _ref.required;
  return /*#__PURE__*/_jsxs("div", {
    "aria-labelledby": "".concat(groupName, "-label"),
    className: cc([css.radioGroup, _defineProperty({}, css.long, long)]),
    role: "radiogroup",
    children: [/*#__PURE__*/_jsx("div", {
      className: css.fieldText,
      id: "".concat(groupName, "-label"),
      children: groupLabel
    }), radios.map(function (_ref3) {
      var key = _ref3.key,
          label = _ref3.label,
          value = _ref3.value;
      return /*#__PURE__*/_jsxs("label", {
        className: css.radio,
        htmlFor: key,
        children: [/*#__PURE__*/_jsx("input", {
          id: key,
          name: groupName,
          onChange: onChange,
          required: required,
          type: "radio",
          value: value
        }), label]
      }, key);
    })]
  });
};

RadioGroup.defaultProps = {
  required: false
};
RadioGroup.propTypes = {
  groupName: PropTypes.string.isRequired,
  groupLabel: PropTypes.string.isRequired,
  long: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  radios: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  required: PropTypes.bool
};

var Field = function Field(_ref4) {
  var disclaimer = _ref4.disclaimer,
      inputType = _ref4.inputType,
      label = _ref4.label,
      long = _ref4.long,
      longMobile = _ref4.longMobile,
      name = _ref4.name,
      onChange = _ref4.onChange,
      required = _ref4.required,
      tall = _ref4.tall,
      textArea = _ref4.textArea,
      truncate = _ref4.truncate,
      value = _ref4.value;
  return /*#__PURE__*/_jsxs("label", {
    className: cc([css.field, _defineProperty({}, css.long, long), _defineProperty({}, css.longMobile, longMobile), _defineProperty({}, css.tall, tall)]),
    htmlFor: "ambassador-".concat(name),
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.fieldText, _defineProperty({}, css.truncate, truncate)]),
      children: label
    }), !textArea && /*#__PURE__*/_jsx("input", {
      id: "ambassador-".concat(name),
      maxLength: 100,
      name: name,
      onChange: onChange,
      required: required,
      type: inputType,
      value: value
    }), textArea && /*#__PURE__*/_jsx("textarea", {
      id: "ambassador-".concat(name),
      maxLength: 768,
      name: name,
      onChange: onChange,
      required: required,
      type: inputType,
      value: value
    }), disclaimer && /*#__PURE__*/_jsx("p", {
      className: css.disclaimer,
      children: disclaimer
    })]
  });
};

Field.defaultProps = {
  disclaimer: false,
  inputType: 'text',
  long: false,
  longMobile: false,
  required: false,
  tall: false,
  textArea: false,
  truncate: false
};
Field.propTypes = {
  disclaimer: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  inputType: PropTypes.string,
  label: PropTypes.string.isRequired,
  long: PropTypes.bool,
  longMobile: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  tall: PropTypes.bool,
  textArea: PropTypes.bool,
  truncate: PropTypes.bool,
  value: PropTypes.string.isRequired
};

var Form = function Form(_ref9) {
  var onHide = _ref9.onHide,
      open = _ref9.open;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      first = _useState2[0],
      setFirst = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      last = _useState4[0],
      setLast = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      email = _useState6[0],
      setEmail = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      city = _useState8[0],
      setCity = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      errors = _useState10[0],
      setErrors = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      instagram = _useState12[0],
      setInstagram = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      site = _useState14[0],
      setSite = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      tikTok = _useState16[0],
      setTikTok = _useState16[1];

  var _useState17 = useState(''),
      _useState18 = _slicedToArray(_useState17, 2),
      twitter = _useState18[0],
      setTwitter = _useState18[1];

  var _useState19 = useState(''),
      _useState20 = _slicedToArray(_useState19, 2),
      youtube = _useState20[0],
      setYoutube = _useState20[1];

  var _useState21 = useState(''),
      _useState22 = _slicedToArray(_useState21, 2),
      why = _useState22[0],
      setWhy = _useState22[1];

  var _useState23 = useState(''),
      _useState24 = _slicedToArray(_useState23, 2),
      fav = _useState24[0],
      setFav = _useState24[1]; // checkboxes


  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      optIn = _useState26[0],
      setOptIn = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      ofAge = _useState28[0],
      setOfAge = _useState28[1];

  var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      undergrad = _useState30[0],
      setUndergrad = _useState30[1];

  var _useState31 = useState(INFLUENCER_PLATFORMS),
      _useState32 = _slicedToArray(_useState31, 2),
      influencerPlatforms = _useState32[0],
      setInfluencerPlatforms = _useState32[1];

  var _useState33 = useState(''),
      _useState34 = _slicedToArray(_useState33, 2),
      platformOther = _useState34[0],
      setPlatformOther = _useState34[1]; // selects


  var _useState35 = useState(''),
      _useState36 = _slicedToArray(_useState35, 2),
      referrer = _useState36[0],
      setReferrer = _useState36[1];

  var _useState37 = useState(''),
      _useState38 = _slicedToArray(_useState37, 2),
      state = _useState38[0],
      setState = _useState38[1];

  var _useState39 = useState(''),
      _useState40 = _slicedToArray(_useState39, 2),
      dobMonth = _useState40[0],
      setDobMonth = _useState40[1];

  var _useState41 = useState(''),
      _useState42 = _slicedToArray(_useState41, 2),
      dobDay = _useState42[0],
      setDobDay = _useState42[1]; // radio groups


  var _useState43 = useState('No'),
      _useState44 = _slicedToArray(_useState43, 2),
      fitnessInstructor = _useState44[0],
      setFitnessInstructor = _useState44[1];

  var _useState45 = useState('Yes'),
      _useState46 = _slicedToArray(_useState45, 2),
      inUSorCA = _useState46[0],
      setInUSorCA = _useState46[1];

  var _useState47 = useState(false),
      _useState48 = _slicedToArray(_useState47, 2),
      submitting = _useState48[0],
      setSubmitting = _useState48[1];

  var _useState49 = useState(false),
      _useState50 = _slicedToArray(_useState49, 2),
      submitted = _useState50[0],
      setSubmitted = _useState50[1];

  var daysInMonth = getDaysInMonth(dobMonth);
  var isValid = referrer !== '' && state !== '' && dobMonth != '' && dobDay != '';

  var onChangeRadio = function onChangeRadio(event, setFunction) {
    return setFunction(event.target.value);
  };

  var onChangePlatform = function onChangePlatform(platformLabelToUpdate) {
    setInfluencerPlatforms(influencerPlatforms.map(function (platform) {
      if (platform.label !== platformLabelToUpdate) {
        return platform;
      }

      return _objectSpread(_objectSpread({}, platform), {}, {
        checked: !platform.checked
      });
    }));
  };

  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    setErrors([]);

    if (!isValid) {
      var newErrors = [];

      if (!referrer) {
        newErrors.push('Please let us know how you heard about the Doing Things Network.');
      }

      if (!state) {
        newErrors.push('Please enter your state.');
      }

      if (!dobMonth || !dobDay) {
        newErrors.push('Please enter your birthdate.');
      }

      setErrors(newErrors);
      return;
    } // build out address


    var address = "".concat(city, ", ").concat(state);
    var influencerAffiliatePlatforms = influencerPlatforms.filter(function (_ref10) {
      var checked = _ref10.checked,
          label = _ref10.label;
      return checked === true && label !== 'Other';
    }).map(function (_ref11) {
      var label = _ref11.label;
      return label;
    }).join(', ');

    if (platformOther !== '') {
      influencerAffiliatePlatforms = influencerAffiliatePlatforms + ', ' + platformOther;
    }

    var body = {
      first: first,
      last: last,
      email: email,
      instagram: instagram,
      tikTok: tikTok,
      twitter: twitter,
      youtube: youtube,
      site: site,
      ofAge: ofAge ? 'Yes' : 'No',
      activities: fav,
      reason: why,
      address: address,
      referrer: referrer !== '' ? referrerOptions[parseInt(referrer, 10)].label : 'Other',
      fitnessInstructor: fitnessInstructor ? 'Yes' : 'No',
      birthDate: getPaddedNumString(dobMonth) + '/' + getPaddedNumString(dobDay),
      undergraduate: undergrad ? 'Yes' : 'No',
      influencerAffiliatePlatforms: influencerAffiliatePlatforms,
      inUSorCA: inUSorCA
    };
    setSubmitting(true);
    fetch(SUBMIT_URL, {
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }).then(function () {
      return setSubmitted(true);
    }).catch(function (error) {
      return console.error(error);
    }); // send email capture

    if (optIn) {
      fetch(OV_SUBSCRIBE_URL, {
        body: JSON.stringify({
          email: email,
          first_name: first,
          last_name: last,
          source: 'Doer Application'
        }),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
    }
  };

  return /*#__PURE__*/_jsx("div", {
    className: cc([css.form, _defineProperty({}, css.open, open)]),
    children: /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsx("button", {
        "aria-label": "Return To Doer Landing Page And Close dialog",
        className: css.close,
        onClick: onHide,
        title: "Close Button",
        type: "button",
        children: /*#__PURE__*/_jsx(XLarge, {})
      }), /*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: submitted ? SUCCESS_TITLE : FORM_TITLE
      }), /*#__PURE__*/_jsx("h3", {
        "aria-live": "polite",
        className: css.subtitle,
        dangerouslySetInnerHTML: {
          __html: submitted ? SUCESS_SUBTITLE : FORM_SUBTITLE
        },
        role: "status"
      }), !submitted && /*#__PURE__*/_jsxs("form", {
        onSubmit: onSubmit,
        children: [/*#__PURE__*/_jsxs("div", {
          className: css.referrerWrap,
          children: [/*#__PURE__*/_jsx("div", {
            className: css.fieldText,
            children: "How did you hear about the Doing Things Network?"
          }), /*#__PURE__*/_jsx(Select, {
            buttonProps: {
              bordered: true
            },
            label: "Choose One",
            name: "heardAboutFrom",
            onChange: function onChange(e) {
              return setReferrer(String(e.target.value));
            },
            options: referrerOptions,
            placeholder: "Choose One",
            required: true,
            value: referrer
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: css.formInner,
          children: [/*#__PURE__*/_jsx(Field, {
            autoComplete: "given-name",
            label: "First Name",
            name: "first",
            onChange: function onChange(e) {
              return setFirst(e.target.value);
            },
            required: true,
            value: first
          }), /*#__PURE__*/_jsx(Field, {
            autoComplete: "family-name",
            label: "Last Name",
            name: "last",
            onChange: function onChange(e) {
              return setLast(e.target.value);
            },
            required: true,
            value: last
          }), /*#__PURE__*/_jsx(Field, {
            autoComplete: "email",
            inputType: "email",
            label: "Email",
            longMobile: true,
            name: "email",
            onChange: function onChange(e) {
              return setEmail(e.target.value);
            },
            required: true,
            type: "email",
            value: email
          }), /*#__PURE__*/_jsx("div", {
            className: css.checkboxWrap,
            children: /*#__PURE__*/_jsx(CheckBox, {
              checked: optIn,
              label: OPT_IN_LABEL,
              name: "opt-in",
              onChange: function onChange(e) {
                return setOptIn(!e.target.value);
              },
              value: optIn
            })
          }), /*#__PURE__*/_jsx(RadioGroup, {
            groupName: "inUSorCA",
            groupLabel: "Are you based in the US or Canada?",
            long: true,
            onChange: function onChange(event) {
              return onChangeRadio(event, setInUSorCA);
            },
            required: true,
            radios: [{
              key: 'inUSorCA-yes',
              label: 'Yes',
              value: 'Yes'
            }, {
              key: 'inUSorCA-no',
              label: 'No',
              value: 'No'
            }]
          }), /*#__PURE__*/_jsx(Field, {
            label: "City",
            name: "city",
            onChange: function onChange(e) {
              return setCity(e.target.value);
            },
            required: true,
            value: city
          }), /*#__PURE__*/_jsx("div", {
            className: css.stateWrap,
            children: /*#__PURE__*/_jsx(Select, {
              autoComplete: "address-level1",
              buttonProps: {
                bordered: true
              },
              label: "State",
              long: true,
              name: "state",
              onChange: function onChange(e) {
                return setState(e.target.value);
              },
              options: states.map(function (_ref13) {
                var label = _ref13.label,
                    value = _ref13.value;
                return {
                  label: label,
                  value: value
                };
              }),
              placeholder: "State",
              required: true,
              value: state
            })
          }), /*#__PURE__*/_jsx(Field, {
            disclaimer: "*Please note: Instagram account must be public for consideration.",
            label: "Instagram Handle",
            longMobile: true,
            name: "instagram",
            onChange: function onChange(e) {
              return setInstagram(e.target.value);
            },
            required: true,
            value: instagram
          }), /*#__PURE__*/_jsx(Field, {
            label: "Blog/Website (optional)",
            name: "site",
            onChange: function onChange(e) {
              return setSite(e.target.value);
            },
            truncate: true,
            value: site
          }), /*#__PURE__*/_jsx(Field, {
            label: "TikTok (optional)",
            name: "tikTok",
            onChange: function onChange(e) {
              return setTikTok(e.target.value);
            },
            truncate: true,
            value: tikTok
          }), /*#__PURE__*/_jsx(Field, {
            label: "Twitter (optional)",
            name: "twitter",
            onChange: function onChange(e) {
              return setTwitter(e.target.value);
            },
            truncate: true,
            value: twitter
          }), /*#__PURE__*/_jsx(Field, {
            label: "Youtube Link (optional)",
            name: "youtube",
            onChange: function onChange(e) {
              return setYoutube(e.target.value);
            },
            truncate: true,
            value: youtube
          }), /*#__PURE__*/_jsx(RadioGroup, {
            groupName: "fitnessInstructor",
            groupLabel: "Are you a fitness instructor?",
            long: false,
            onChange: function onChange(event) {
              return onChangeRadio(event, setFitnessInstructor);
            },
            radios: [{
              key: 'fitnessInstructor-yes',
              label: 'Yes',
              value: 'Yes'
            }, {
              key: 'fitnessInstructor-no',
              label: 'No',
              value: 'No'
            }]
          }), /*#__PURE__*/_jsxs("div", {
            className: css.dobWrap,
            children: [/*#__PURE__*/_jsx("div", {
              className: css.fieldText,
              children: DOB_LABEL
            }), /*#__PURE__*/_jsx(Select, {
              buttonProps: {
                bordered: true
              },
              label: "Month",
              long: true,
              name: "dobMonth",
              onChange: function onChange(e) {
                var newMonthNum = e.target.value;
                var maxDaysNewMonth = getDaysInMonth(newMonthNum);
                setDobMonth(newMonthNum);

                if (dobDay >= maxDaysNewMonth) {
                  setDobDay(maxDaysNewMonth - 1);
                }
              },
              options: Array(12).fill().map(function (e, monthNum) {
                return {
                  label: getPaddedNumString(monthNum),
                  value: monthNum + 1
                };
              }),
              placeholder: "MM",
              required: true,
              value: dobMonth
            }), /*#__PURE__*/_jsx(Select, {
              buttonProps: {
                bordered: true
              },
              label: "Day",
              long: true,
              name: "dobDay",
              onChange: function onChange(e) {
                return setDobDay(e.target.value);
              },
              options: Array(daysInMonth).fill().map(function (e, dayNum) {
                return {
                  label: getPaddedNumString(dayNum),
                  value: dayNum + 1
                };
              }),
              placeholder: "DD",
              required: true,
              value: dobDay
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: css.checkboxWrap,
            children: /*#__PURE__*/_jsx(CheckBox, {
              checked: ofAge,
              label: OF_AGE_LABEL,
              name: "of-age",
              required: true,
              onChange: function onChange(e) {
                return setOfAge(!e.target.value);
              },
              value: ofAge
            })
          }), /*#__PURE__*/_jsx("div", {
            className: css.checkboxWrap,
            children: /*#__PURE__*/_jsx(CheckBox, {
              checked: undergrad,
              label: UNDERGRAD_LABEL,
              name: "undergrad",
              onChange: function onChange(e) {
                return setUndergrad(!e.target.value);
              },
              value: undergrad
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: css.platformsWrap,
            children: [/*#__PURE__*/_jsx("div", {
              className: css.fieldText,
              children: INFLUENCER_PLATFORMS_LABEL
            }), influencerPlatforms.map(function (_ref14) {
              var checked = _ref14.checked,
                  label = _ref14.label;
              return /*#__PURE__*/_jsxs("div", {
                className: css.platformCheckBox,
                children: [/*#__PURE__*/_jsx(CheckBox, {
                  checked: checked,
                  label: label,
                  name: label,
                  onChange: function onChange() {
                    return onChangePlatform(label);
                  },
                  value: checked
                }), label === 'Other' && checked && /*#__PURE__*/_jsx("input", {
                  className: css.platformOther,
                  maxLength: 100,
                  name: "platform-other",
                  onChange: function onChange(event) {
                    return setPlatformOther(event.target.value);
                  },
                  type: "text",
                  value: platformOther
                })]
              }, label);
            })]
          }), /*#__PURE__*/_jsx(Field, {
            label: FAV_COPY,
            long: true,
            name: "fav",
            onChange: function onChange(e) {
              return setFav(e.target.value);
            },
            required: true,
            value: fav
          }), /*#__PURE__*/_jsx(Field, {
            label: WHY_COPY,
            long: true,
            name: "why",
            onChange: function onChange(e) {
              return setWhy(e.target.value);
            },
            required: true,
            tall: true,
            textArea: true,
            value: why
          }), errors.length > 0 && /*#__PURE__*/_jsx("div", {
            children: errors.map(function (error) {
              return /*#__PURE__*/_jsx("p", {
                className: css.error,
                children: error
              }, "error-".concat(error));
            })
          }), /*#__PURE__*/_jsx("div", {
            className: css.submitWrap,
            children: /*#__PURE__*/_jsx(Button, {
              disabled: submitting,
              type: "submit",
              children: submitting ? DT : 'Submit'
            })
          })]
        })]
      }), submitted && /*#__PURE__*/_jsx(ShopBlocks, {})]
    })
  });
};

Form.propTypes = {
  onHide: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

var FormManager = function FormManager(_ref15) {
  var onHide = _ref15.onHide,
      open = _ref15.open;
  useEffect(function () {
    return fixScroll(open);
  }, [open]);
  return /*#__PURE__*/_jsx("section", {
    className: css.root,
    children: /*#__PURE__*/_jsx(Overlay, {
      onHide: onHide,
      on: open,
      children: /*#__PURE__*/_jsx(Form, {
        onHide: onHide,
        open: open
      })
    })
  });
};

FormManager.propTypes = {
  onHide: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
export default FormManager;